import { get } from '~http';

async function getPaymentSlips(resellerDocument: string, params?: any) {
  try {
    const response: MySsApiResponse = await get('invoices/paymentSlips', { resellerDocument, ...params });

    return {
      paymentSlipList: response.data.data.items.map((paymentSlipsDto: IPaymentSlipDTO) => new PaymentSlip(paymentSlipsDto)),
      pagination: { ...response.data.data.pagination },
    };
  }
  catch (error) {
    throw errorTreatment(error);
  }
}

export async function listPaymentSlips(resellerDocument: string) {
  return await getPaymentSlips(resellerDocument);
}

export async function filterPaymentSlips(resellerDocument: string, filters: any, pagination = { ...PAGINATION }) {
  try {
    const params = adaptQueryParams<any, any>(filters, pagination, preparePaymentSlipListFilterParams_v2);
    return await getPaymentSlips(resellerDocument, params);
  }
  catch (error) {
    throw errorTreatment(error);
  }
}

export async function getPaymentLink(resellerDocument: string, invoiceNumber: string, invoiceSerieNumber: string) {
  return await get('payments', { resellerDocument, invoiceNumber, invoiceSerieNumber }).then(
    (response: any) => response.data.data,
    (error: any) => {
      error.messages[0] = 'EXCEPTIONS.UNEXPECTED_FILE'
      throw error;
     },
  );
}
